import React, { useEffect, useRef } from "react";
import { Container, Row } from "react-bootstrap";

const WavingCircleFlag = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        drawCircleWithGlow(canvas, 300); // Larger canvas to hold glow
        waveFlag(canvas, 20, 8, 120, 180, -0.15);
    }, []);

    function drawCircleWithGlow(canvas, size) {
        const ctx = canvas.getContext("2d");
        canvas.width = size;
        canvas.height = size;

        const centerX = size / 2;
        const centerY = size / 2;
        const radius = size / 2.2;

        // ✅ 1. Radial Glow (Black glow layer part of canvas)
        const glow = ctx.createRadialGradient(centerX, centerY, radius * 0.6, centerX, centerY, radius * 1.8);
        glow.addColorStop(0, "rgba(0,0,0,0)");
        glow.addColorStop(1, "rgba(0,0,0,0)");
        ctx.fillStyle = glow;
        ctx.fillRect(0, 0, size, size);

        // ✅ 2. Gradient Circle Fill
        const gradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius);
        gradient.addColorStop(0, "rgba(61,120,76,0.7"); // Yellow center
        gradient.addColorStop(1, "rgba(197,255,21,0.5"); // Green edge
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fill();


    }

    function waveFlag(canvas, wavelength, amplitude, period, shading, squeeze) {
        const ctx = canvas.getContext("2d");
        const w = canvas.width, h = canvas.height;
        const od = ctx.getImageData(0, 0, w, h).data;

        return setInterval(() => {
            const id = ctx.getImageData(0, 0, w, h);
            const d = id.data;
            const now = Date.now() / period;

            for (let y = 0; y < h; ++y) {
                let lastO = 0;
                const sq = (y - h / 2) * squeeze;
                for (let x = 0; x < w; ++x) {
                    const px = (y * w + x) * 4;
                    const pct = x / w;
                    const o = Math.sin(x / wavelength - now) * amplitude * pct;
                    const y2 = y + (o + sq * pct) << 0;
                    const opx = (y2 * w + x) * 4;

                    d[px] = od[opx];
                    d[px + 1] = od[opx + 1];
                    d[px + 2] = od[opx + 2];
                    d[px + 3] = od[opx + 3];
                    lastO = o;
                }
            }

            ctx.putImageData(id, 0, 0);
        }, 1000 / 30);
    }

    return (
        <Container className="text-center mt-5">
            <Row className="justify-content-center">
                <div
                    className="circle-flag-div"
                >
                    <canvas
                        ref={canvasRef}

                        className="canvas-div"
                    />
                </div>
            </Row>
        </Container>

    );
};

export default WavingCircleFlag;
